/**
 * add accordion functionality for menu items to .s-footer selector
 */
import jQuery from 'jquery'
// import * as lib from '../lib/lib'

export default class LeasingContact {
  constructor(element) {
    if (!element) {
      return false
    }

    this.$element = jQuery(element)

    const google = window.google

    if (google) {
      const maps = google.maps
      if (maps) {
        this._initMap()
      }
    }

    document.addEventListener('google-map-ready', () => {
      this._initMap()
    })
  }

  _initMap() {
    const google = window.google

    const defaultZoomLevel = 16

    const mapDiv = document.getElementById('map')

    if (!mapDiv) {
      return false
    }

    const li = mapDiv.querySelector('li')

    const lat = li.dataset.lat
    const lng = li.dataset.lng

    const map = new google.maps.Map(mapDiv, {
      disableDefaultUI: true,
      zoom: defaultZoomLevel,
      zoomControl: true,
      mapTypeId: 'roadmap',
    })

    const icon = '/imgs/misc/GoogleMapsMarker.png'

    // Create markers.

    const position = new google.maps.LatLng(lat, lng)

    const marker = new google.maps.Marker({
      position: position,
      icon: icon,
      map: map,
    })

    map.setCenter(marker.getPosition())
  }
}
